import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../../shared/hooks/useAuth';

const ProtectedRoute = () => {
  const { authenticated } = useAuth();
  const { pathname } = useLocation();

  const getPathName = pathname === '/' ? '' : `?redirectUrl=${pathname}`;

  if (!authenticated) {
    return (
      <Navigate
        replace
        to={`${'/sign-in'}${getPathName}`}
      />
    )
  };

  return <Outlet />;
};

export default ProtectedRoute;